export enum ReturnStates {
  ORDER_SUMMARY = "ORDER_SUMMARY",
  REASON_SELECTION = "REASON_SELECTION",
  SELECT_RETURN_ITEMS = "SELECT_RETURN_ITEMS",
  EXCHANGE_VARIANT = "EXCHANGE_VARIANT",
  EXCHANGE_PRODUCT = "EXCHANGE_PRODUCT",
  ORDER_TRACKING = "ORDER_TRACKING",
  RETURN_CONFIRMATION = "RETURN_CONFIRMATION",
  RETURN_TRACKING = "RETURN_TRACKING",
}
